export const STATIC_EVENTS = [
  {
    _id: "static-1",
    id: "1",
    title: "Sihah convecation",
    headerDesc: "Memories from the beautiful Sihah convecation event.",
    description: "Memories from the beautiful Sihah convecation event.",
    imageUrl: "/assets/gallery/Sihah%20convecation/111.jpeg",
    isStatic: true,
    gridImages: [
      "/assets/gallery/Sihah%20convecation/111.jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.52%20PM%20(1).jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.52%20PM.jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.53%20PM%20(1).jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.53%20PM%20(2).jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.53%20PM.jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.54%20PM%20(1).jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.55%20PM%20(1).jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.55%20PM.jpeg",
      "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.56%20PM.jpeg",
    ],
    bottomTitle: "Sihah Convocation Gathering",
    bottomDesc1: "A grand convocation ceremony celebrating the academic and spiritual achievements of students in Prophetic Hadith studies.",
    bottomDesc2: "Distinguished scholars and guests joined together to honor the graduates and pray for their journey ahead."
  },
  {
    _id: "static-2",
    id: "2",
    title: "Masjid inauguration",
    headerDesc: "Glimpses of our grand Masjid inauguration ceremony.",
    description: "Glimpses of our grand Masjid inauguration ceremony.",
    imageUrl: "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.53%20PM%20(1).jpeg",
    isStatic: true,
    gridImages: [
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.53%20PM%20(1).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.53%20PM.jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.54%20PM%20(1).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.54%20PM.jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.55%20PM%20(1).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.55%20PM%20(2).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.55%20PM.jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.56%20PM%20(1).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.56%20PM.jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.57%20PM%20(1).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.57%20PM.jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.58%20PM%20(1).jpeg",
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.58%20PM.jpeg",
    ],
    bottomTitle: "Grand Masjid Inauguration Ceremony",
    bottomDesc1: "Moments from the blessed opening of our new Masjid, bringing together community leaders, scholars, and well-wishers.",
    bottomDesc2: "The ceremony was filled with prayers, speeches, and shared joy as the doors were officially opened."
  },
  {
    _id: "static-3",
    id: "3",
    title: "Imlaa'",
    headerDesc: "Highlights from the Imlaa' gathering.",
    description: "Highlights from the Imlaa' gathering.",
    imageUrl: "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.17%20PM.jpeg",
    isStatic: true,
    gridImages: [
      "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.17%20PM.jpeg",
      "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.18%20PM%20(1).jpeg",
      "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.18%20PM.jpeg",
      "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.19%20PM%20(1).jpeg",
      "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.19%20PM.jpeg",
    ],
    bottomTitle: "Imlaa' Sacred Gathering",
    bottomDesc1: "Highlights from the traditional dictation and transcription sessions of classic Islamic texts.",
    bottomDesc2: "Students and scholars engaged in preserving sacred knowledge with precision and dedication."
  },
  {
    _id: "static-4",
    id: "4",
    title: "Hadees seminar",
    headerDesc: "A scholarly journey into Prophetic Traditions, exploring modern challenges and solutions.",
    description: "A scholarly journey into Prophetic Traditions, exploring modern challenges and solutions.",
    imageUrl: "/assets/events/hadees seminar.jpeg",
    isStatic: true,
    gridImages: [
      "/assets/events/hadees seminar.jpeg",
      "/assets/events/hadees seminar_2.jpeg",
      "/assets/events/hadees seminar_3.jpeg",
      "/assets/events/hadees seminar_4.jpeg",
      "/assets/events/hadees seminar_5.jpeg",
      "/assets/events/hadees seminar_6.jpeg",
    ],
    bottomTitle: "Prophetic Traditions Seminar",
    bottomDesc1: "An enlightening seminar exploring Hadith sciences and their application to contemporary contexts.",
    bottomDesc2: "Renowned Islamic scholars presented research papers and led interactive discussion sessions."
  },
  {
    _id: "static-5",
    id: "5",
    title: "AL BIDAYA",
    headerDesc: "Highlights from the AL BIDAYA event.",
    description: "Highlights from the AL BIDAYA event.",
    imageUrl: "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.54%20PM%20(2).jpeg",
    isStatic: true,
    gridImages: [
      "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.54%20PM%20(2).jpeg",
      "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.54%20PM%20(1).jpeg",
      "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.54%20PM.jpeg",
      "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.55%20PM%20(1).jpeg",
      "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.55%20PM%20(2).jpeg",
      "/assets/gallery/AL%20BIDAYA/WhatsApp%20Image%202026-03-04%20at%203.14.55%20PM.jpeg",
    ],
    bottomTitle: "AL BIDAYA Inaugural Event",
    bottomDesc1: "Celebrating new beginnings with inspiring talks, presentations, and educational showcases.",
    bottomDesc2: "Bringing together faculty, students, and guests for a memorable commencement."
  },
  {
    _id: "static-6",
    id: "6",
    title: "Qhathmul bukhari majlis",
    headerDesc: "Highlights from the Qhathmul bukhari majlis event.",
    description: "Highlights from the Qhathmul bukhari majlis event.",
    imageUrl: "/assets/gallery/Qhathmul%20bukhari%20majlis/4.jpeg",
    isStatic: true,
    gridImages: [
      "/assets/gallery/Qhathmul%20bukhari%20majlis/4.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/1.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/2.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/3.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/5.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/6.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/7.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/8.jpeg",
      "/assets/gallery/Qhathmul%20bukhari%20majlis/9.jpeg",
    ],
    bottomTitle: "Qhathmul Bukhari Sacred Majlis",
    bottomDesc1: "A solemn and spiritual gathering marking the completion of Sahih al-Bukhari recitation.",
    bottomDesc2: "Attended by esteemed scholars and community members seeking blessings and knowledge."
  }
];
